import { IOmniaSession } from "../types"
import { isString } from "../utils/utils"

/** @interal */
export function parseInvite(invite: string): IOmniaSession["invite"] {

    if (!invite) {
        return
    }

    const p = JSON.parse(atob(invite))

    return (isString(p["id"]) && (p["type"] === "holding"))
        ? {
            queryString: invite,
            ...p
        }
        : undefined

}
